import useLayersState from "./useLayersState";
import useFeaturesState from "./useFeaturesState";
import {useSidePanel} from "../../../components/SidePanel";
import useDataPanel from "./useDataPanel";


const useWebgis = () => {
    const layersState = useLayersState();
    const featuresState = useFeaturesState({layersState})
    const filterPanel = useSidePanel();
    const dataPanel = useDataPanel({featuresState, layersState});

    // Handle auto-opening data panel and content switching when a feature is selected
    const handleFeatureClick = (feature, type, event) => {
        let handleFeatureClick, isFeatureSelected;
        const tableContentId = type + 'Table';

        if (type === 'station') {
            handleFeatureClick = featuresState.stationSelectedState.handleFeatureClick;
            isFeatureSelected = featuresState.stationSelectedState.isFeatureSelected;
        } else if (type === 'model23') {
            handleFeatureClick = featuresState.model23SelectedState.handleFeatureClick;
            isFeatureSelected = featuresState.model23SelectedState.isFeatureSelected;
        } else if (type === 'model1') {
            handleFeatureClick = featuresState.model1SelectedState.handleFeatureClick;
            isFeatureSelected = featuresState.model1SelectedState.isFeatureSelected;
        } else if (type === 'incident'){
            handleFeatureClick = featuresState.incidentSelectedState.handleFeatureClick;
            isFeatureSelected = featuresState.incidentSelectedState.isFeatureSelected;
        } else {
            throw new Error(`Unknown feature type: ${type}`);
        }

        // If the feature is not already selected, open the data panel and switch to the appropriate content
        if (!isFeatureSelected(feature)){
            dataPanel.open();
            dataPanel.setActiveContentType(prev => prev === tableContentId ? tableContentId : type)
        }

        // Call the handler to update state
        handleFeatureClick(feature, event);
    }

    return {
        layersState,
        featuresState,
        filterPanel,
        dataPanel,
        handleStationClick: (feature, event) => handleFeatureClick(feature, 'station', event),
        handleModel23Click: (feature, event) => handleFeatureClick(feature, 'model23', event),
        handleModel1Click: (feature, event) => handleFeatureClick(feature, 'model1', event),
        handleIncidentClick: (feature, event) => handleFeatureClick(feature, 'incident', event),
    }
}

export default useWebgis;